import { ReactElement } from "react";

import { useEntityPropertyKeyNormalized } from "@ryde/redux";
import { IEntityPropertyObject, RydeUiUnit } from "@ryde/shared";

import { Collapse } from "../collapse";
import { EntityProperties } from "./entity-properties";
import { EntityPropertyPlaceholderValue } from "./entity-property-placeholder-value";
import { useEntityPropertyCollapse } from "./use-entity-property-collapse";

interface IEntityPropertyObjectProps {
  entity?: RydeUiUnit;
  entityProperty: IEntityPropertyObject;
}

export const EntityPropertyObject = ({
  entity,
  entityProperty,
}: IEntityPropertyObjectProps): ReactElement => {
  const propertyKey = useEntityPropertyKeyNormalized({
    entity,
    entityProperty,
  });
  const { isCollapsed, onToggle } = useEntityPropertyCollapse(
    !!entityProperty.properties?.length,
  );

  return (
    <Collapse
      isSkipMaxHeight
      isInner
      isCollapsed={isCollapsed}
      onToggleCollapsed={onToggle}
      CollapseHeader={
        <EntityPropertyPlaceholderValue
          label={propertyKey}
          value="{...}"
          isOpen={isCollapsed}
        />
      }
    >
      <EntityProperties entity={entity} data={entityProperty.properties} />
    </Collapse>
  );
};
